import React from 'react';
import { AlertMessage } from '../../../../../../../../../../components/AlertMessage';

interface PropTypes {
  totalCount: number;
}

export function PendingExecutionsAlert(props: PropTypes) {
  return (
    <AlertMessage
      hasOverlay={false}
      icon={{ name: 'bi-exclamation-triangle' }}
      className='fs-5 bg-yellow-light w-100 mb-3'
      text={
        <>
          There are <strong>{props.totalCount}</strong> pending automation
          executions scheduled. Removing this will cancel all the executions. Do
          you want to remove this automation?
        </>
      }
    />
  );
}
